import type { FC } from "react";

import { OverviewContainer } from "@components/OverviewContainer/OverviewContainer";
import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { usePerimeterConsoAction } from "@hooks/usePerimeterConsoAction";
import { useGetGroup } from "@services/apiEcms/useGetGroup";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./PerimeterCustomers.module.css";
import { PerimeterCustomersTable } from "./PerimeterCustomersTable/PerimeterCustomersTable";

export const PerimeterCustomers: FC = () => {
  const { t } = useCustomTranslation("main");
  const { currentGroup } = useGroupReferences();
  const { isLoading } = useGetGroup({
    groupId: currentGroup,
  });

  const { gas, elec, energiesLoading } = usePerimeterConsoAction({
    isSearch: true,
  });

  return (
    <div className={classes.container}>
      <OverviewContainer
        areEnergiesLoading={energiesLoading}
        elec={elec}
        gas={gas}
        isGroupLoading={isLoading}
        levelData={{
          title: t("perimeter.customers.title"),
          data: [],
        }}
      />
      <PerimeterCustomersTable />
    </div>
  );
};
